
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWind2 as ObiWind2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-2.js';
 
 
 

 
 export const ObiWind2 = createComponent({
   react: React,
   tagName: 'obi-wind-2',
   elementClass: ObiWind2Element,
   events: {
     
   }
  });
 
 